// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_vg7","cls2":"Comments-cls2_QTh Comments-cls1_vg7"};